import React from 'react';
import {useTranslation} from 'react-i18next';
import {Citation} from '../../../models/models';
import {
    CitationButton,
    CitationButtonsContainer,
    CitationCard,
    CitationContent,
    CitationSource
} from "./MessageCitations.styled";
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import {theme, tokens} from "../../../theme";
import {Link} from "@mui/material";

interface MessageCitationsProps {
    citations: Citation[];
    openIndex: number | null;
    onToggle: (index: number) => void;
}

export const MessageCitations = ({
    citations,
    openIndex,
    onToggle,
}: MessageCitationsProps) => {
    const { t } = useTranslation();

    if (!citations || citations.length === 0) {
        return null;
    }

    return (
        <>
            <CitationButtonsContainer>
                {citations.map((_, citatIndex) => (
                    <CitationButton
                        key={`citation-btn-${citatIndex}`}
                        $isActive={openIndex === citatIndex}
                        onClick={() => onToggle(citatIndex)}
                    >
                        <FormatQuoteIcon style={{color: openIndex === citatIndex ? theme.palette.primary.contrastText : theme.palette.primary.main, fontSize: tokens.fontSize.base }} />
                        {t('chatMessages.citation')} {citatIndex + 1}
                    </CitationButton>
                ))}
            </CitationButtonsContainer>

            {openIndex !== null && citations[openIndex] && (
                <CitationCard style={{ marginTop: '12px' }}>
                    <CitationSource>
                        <span style={{ fontWeight: tokens.fontWeight.semibold }}>{t('chatMessages.documentName')}</span>
                        <Link href={`/documents/view/${citations[openIndex].documentId}`}
                              sx={{ fontWeight: tokens.fontWeight.semibold }}
                              target="_blank"
                              rel="noopener noreferrer"
                        >
                            {citations[openIndex].documentName ? citations[openIndex].documentName : t('chatMessages.sourceName')}
                        </Link>
                    </CitationSource>

                    <CitationContent style={{ whiteSpace: 'pre-wrap' }}>
                        {citations[openIndex].content}
                    </CitationContent>
                </CitationCard>
            )}
        </>
    );
};

export default MessageCitations;